import {Routes} from "@angular/router";

export const PROFILE_CONFIG_CHILD_ROUTES: Routes = [
  {
    path: ':profileName',
    loadComponent: () => import('../profile-settings/profile-settings.component').then((c) => c.ProfileSettingsComponent),
    children: [
      {
        path: "database",
        loadComponent: () => import('../profile-settings/profile-database-settings/profile-database-settings.component').then((c) => c.ProfileDatabaseSettingsComponent)
      },
      {
        path: "apis",
        loadComponent: () => import('../profile-settings/profile-apis-settings/profile-apis-settings.component').then((c) => c.ProfileApisSettingsComponent)
      },
      {
        path: "websocket",
        loadComponent: () => import('../profile-settings/profile-websocket-settings/profile-websocket-settings.component').then((c) => c.ProfileWebsocketSettingsComponent)
      },
      {
        path: "security",
        loadComponent: () => import('../profile-settings/profile-security-settings/profile-security-settings.component').then((c) => c.ProfileSecuritySettingsComponent)
      },
      {
        path: "appEnvironment",
        loadComponent: () => import('../profile-settings/profile-app-environment-settings/profile-app-environment-settings.component').then((c) => c.ProfileAppEnvironmentSettingsComponent)
      },
      {
        path: "oauth",
        loadComponent: () => import('../profile-settings/profile-oauth-settings/profile-oauth-settings.component').then((c) => c.ProfileOauthSettingsComponent)
      },
      {
        path: "runtime",
        loadComponent: () => import('../profile-settings/profile-builoptions-settings/profile-builoptions-settings.component').then((c) => c.ProfileBuiloptionsSettingsComponent)
      }
    ]
  }
];
